/**
 * Utility functions for encrypting and decrypting IDs for URL safety
 */

/**
 * Simple encryption function to obfuscate user IDs in URLs
 * Uses base64 encoding with a simple transformation
 *
 * @param {number|string} id - The user ID to encrypt
 * @return {string} - Encrypted ID string safe for URLs
 */
export function encryptId(id) {
  if (!id) return ''

  // Convert to string and add a prefix for better security
  const idString = `uid_${id}_${Date.now().toString(36)}`

  // Base64 encode
  const encoded = btoa(idString)

  // Replace characters that might cause URL issues
  return encoded.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

/**
 * Decrypt an encrypted ID from URL
 *
 * @param {string} encryptedId - The encrypted ID from URL
 * @return {string|null} - Decrypted user ID or null if invalid
 */
export function decryptId(encryptedId) {
  if (!encryptedId) return null

  try {
    // Restore base64 standard characters
    const base64 = encryptedId.replace(/-/g, '+').replace(/_/g, '/')

    // Decode
    const decoded = atob(base64)

    // Extract ID from the pattern uid_ID_timestamp
    const match = decoded.match(/uid_(\d+)_/)

    if (match && match[1]) {
      return match[1]
    }

    return null
  } catch (e) {
    console.error('Error decrypting ID:', e)
    return null
  }
}
